export enum FloatingMenuPosition {
  RIGHT = 'RIGHT',
  LEFT = 'LEFT',
}
